import { render, staticRenderFns } from "./PanelUsuariosComercio.vue?vue&type=template&id=0ef811eb&"
import script from "./PanelUsuariosComercio.vue?vue&type=script&lang=js&"
export * from "./PanelUsuariosComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports